<template>
  <div :class="['lang-root', customClass, { 'is-compact': compact }]">
    <el-dropdown class="lang-dropdown" @command="handleSetLanguage" trigger="click">
      <span class="el-dropdown-link lang-switch-link" :style="{'color': fontColor}">
        <img
          v-if="!compact"
          :src="currentLang==='zh'?'/static/admin/img/zh.png':'/static/admin/img/en.png'"
          alt="flag"
          class="flag-icon"
        />
        <span v-else class="lang-code">{{ currentLang === 'zh' ? '中' : 'EN' }}</span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item class="lang-item" command="zh">
          <img src="/static/admin/img/zh.png" class="flag-icon"/> 中文
        </el-dropdown-item>
        <el-dropdown-item class="lang-item" command="en">
          <img src="/static/admin/img/en.png" class="flag-icon"/> English
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  props: {
    fontColor: {
      type: String,
      default: '#FFFFFF',
    },
    customClass: {
      type: String,
      default: '',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentLang: "zh"
    }
  },
  mounted() {
    this.currentLang = localStorage.getItem('lang') || 'zh';
  },
  methods: {
    handleSetLanguage(val) {
      this.currentLang = val;
      localStorage.setItem('lang', val);
      this.$i18n.locale = val;
      window.location.reload();
    },
  }
}
</script>
<style>
.lang-item {
  display: flex;
  align-items: center;
}

.lang-item .flag-icon {
  width: 22px;
  height: 15px;
  margin-right: 6px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}
</style>
<style scoped lang="scss">
.lang-root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lang-dropdown {
  cursor: pointer;
  margin-right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lang-switch-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  outline: none;
}

.flag-icon {
  width: 22px;
  height: 15px;
  margin: 0;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.lang-code {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  color: #E2E8F0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.is-compact {
  width: 28px;
  height: 28px;

  .lang-dropdown,
  .lang-switch-link {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/admin/components/Language/index.vue